// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OxbG","placeholdersHeader":"styles_placeholdersHeader__3BAhG","editorStyle":"styles_editorStyle__39_Vj","placeholdersBox":"styles_placeholdersBox__3jMee"};